import { RouteLink } from '@mr-yum/frontend-core/dist/services/routes'
import { UserGroupFilledIcon } from '@mr-yum/frontend-ui'
import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import { useLoggerLegacy } from '@/hooks/useLogger'
import { routes } from '@/lib/routes'

import { ActionBlockItem } from './ActionBlockItem'
import { ActionBlocksLoader } from './ActionBlocksLoader'

interface Props {
  venueSlug: string
  count: number
  tabId: string
  showManageBlock?: boolean
  isActionBlockLoading: boolean
}

export const ManageTabBlock = ({
  venueSlug,
  count,
  tabId,
  showManageBlock,
  isActionBlockLoading,
}: Props) => {
  const intl = useIntl()
  const { logEventLegacy } = useLoggerLegacy()

  if (!showManageBlock) {
    return null
  }

  if (isActionBlockLoading) {
    return <ActionBlocksLoader />
  }

  return (
    <div className="-mr-4 mb-2 mt-3 flex gap-3 overflow-x-auto whitespace-nowrap pr-4 scrollbar-hide md:mr-0 md:pr-0 [&>a]:rounded-md [&>a]:py-1">
      <RouteLink route={routes.socialTabManage} pathData={{ venueSlug, tabId }}>
        <ActionBlockItem
          count={count}
          icon={<UserGroupFilledIcon height={20} width={20} />}
          onClick={() =>
            logEventLegacy('Clicked on on manage my tab on venue landing page')
          }
          aria-label={intl.formatMessage({
            defaultMessage: 'Manage my group order',
            id: 'w5/OUl',
          })}
          heading={
            <FormattedMessage
              defaultMessage="Manage my group order"
              id="w5/OUl"
            />
          }
          showIndicator={false}
        />
      </RouteLink>
    </div>
  )
}
